module.exports = __webpack_public_path__ + "static/media/vfc.ecb9a620.png";